export default __webpack_public_path__ + "static/media/medellin.5f5c6332.png";